import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import { motion } from "framer-motion";

function SkillsBar({ skill, value, isScrolled, index }) {
  return (
    <motion.div
      style={{ width: "100%", marginBottom: "1.5rem" }}
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.06, duration: 0.35 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <p className="lead mb-0" style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
          {skill}
        </p>
        <span style={{ 
          color: 'var(--text-secondary)', 
          fontWeight: 600,
          fontSize: '0.9rem'
        }}>
          {value}%
        </span>
      </div>
      <ProgressBar
        className={!isScrolled ? "progress" : "progress-bar-animation"}
        now={value}
        style={{
          height: '12px',
          borderRadius: '10px',
          backgroundColor: 'var(--bg-tertiary)',
          overflow: 'hidden'
        }}
      />
    </motion.div>
  );
}

export default SkillsBar;
